<template>
  <div>
    <div class="container" v-if="isShow">
      <div class="card" style="padding: 5px">
        <div class="title">
          <van-image width="30" height="32px" :src="contractImg" />
          <span style="flex: 1">{{ refundInfo.contractName.split('【')[0] }}</span>
          <van-tag round type="warning">{{ formatHandel('acconutStatus',refundInfo.acconutStatus) }}</van-tag>
        </div>
        <div class="title">
          <div style="font-size: 15px;margin-left: 36px; flex: 1">{{refundInfo.contractNum}}</div>
        </div>
        <van-tabs v-model="active">
          <van-tab title="申请信息">
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '0' }">执行客户/付款单位</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">执行客户：</span>
                <span class="value">{{ refundInfo.execCustomerName || '--' }}</span>
              </div>
              <div class="item" >
                <span class="key">付款单位：</span>
                <span class="value">{{ refundInfo.payCustName }}</span>
              </div>
              <div class="item" >
                <span class="key">广告类型：</span>
                <span class="value">{{ formatHandel('accountType',refundInfo.accountType) }}</span>
              </div>
              <div class="item" style="padding-left:98px;text-indent:-98px;">
                <span class="key">部门/人员：</span>
                <span class="value">{{ refundInfo.deptName }}<span style="color: #1989fa; margin: 0 5px;">{{ refundInfo.userName }}</span></span>
              </div>
            </div>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '0' }">退款给客户信息</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">充值剩余金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{refundInfo.rechargeRemainMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(refundInfo.rechargeRemainMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">是否退剩余充值金额：</span>
                <span class="value">{{ refundInfo.isRecharge === 2 ? '是' : '否' }}</span>
              </div>
              <div class="item" >
                <span class="key">退款总金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{refundInfo.refundMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(refundInfo.refundMoney)}}</span>
                </span>
              </div>
            </div>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '0' }">退款账户ID明细</van-divider>
            <van-list>
              <van-cell v-for="(item,index) in batchRefundList" :key="index" style="background-color: #e4e4e4;">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div class="contract_detail">
                    <van-tag round type="warning" plain>明细{{ index + 1 }}</van-tag>
                    <div class="item" style="padding-left:70px;text-indent:-70px;">
                      <span class="key">项目名称：</span>
                      <span class="value">{{ item.projectName }}</span>
                    </div>
                    <div class="item">
                      <span class="key">所属服务商ID：</span>
                      <span class="value">{{ item.serviceId }}</span>
                    </div>
                    <div class="item">
                      <span class="key">账户ID：</span>
                      <span class="value">{{ item.accountNo }}</span>
                    </div>
                    <div class="item">
                      <span class="key">充值账户币：</span>
                      <span class="value">{{ item.rechargeMoney }}</span>
                      <span class="key" style="margin-left: 20px;">充值现金金额：</span>
                      <span class="value">{{ item.payMoney }}</span>
                    </div>
                    <div class="item">
                      <span class="key">退款账户币：</span>
                      <span class="value">{{ item.refundRechargeMoney }}</span>
                      <span class="key" style="margin-left: 20px;">退款现金金额：</span>
                      <span class="value">{{ item.refundPayMoney }}</span>
                    </div>
                    <div class="item">
                      <span class="key">账户返点：</span>
                      <span class="value">{{ item.percentage }}%</span>
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '0' }">退款信息</van-divider>
            <div class="list-wrap van-hairline--top">
              <!-- <div class="item" >
                <span class="key">退款单位名称：</span>
                <span class="value">{{ refundInfo.custName }}</span>
              </div>
              <div class="item" >
                <span class="key">开户行：</span>
                <span class="value">{{ refundInfo.bankName }}</span>
              </div>
              <div class="item" >
                <span class="key">退款账号：</span>
                <span class="value">{{ refundInfo.bankNo }}</span>
              </div> -->
              <div class="item" >
                <span class="key">退款信息：</span>
                <span class="value">{{ refundInfo.custName }}</span>
              </div>
              <div class="item" >
                <span class="key">退款内容说明：</span>
                <span class="value">{{ refundInfo.refundReason }}</span>
              </div>
              <div class="item" >
                <span class="key">退款函：</span>
                <span class="value"><van-button type="info" size="mini" plain @click="showImg(refundInfo.refundUrl)" v-if="refundInfo.refundUrl">点击查看</van-button></span>
              </div>
            </div>
            <van-divider content-position="left" :style="{ color: '#666',borderColor: '#c4c4c4', margin: '0' }" v-if="refundInfo.cashierUrl">退款截图</van-divider>
            <div class="list-wrap van-hairline--top" v-if="refundInfo.cashierUrl">
              <div class="item" >
                <span class="key">操作人员：</span>
                <span class="value">{{ refundInfo.cashierName }}</span>
              </div>
              <div class="item" >
                <span class="key">退款时间：</span>
                <span class="value">{{ refundInfo.updateTime }}</span>
              </div>
              <div class="item" >
                <span class="key">退款截图：</span>
                <span class="value"><van-button type="info" size="mini" plain @click="showImg(refundInfo.cashierUrl)" v-if="refundInfo.cashierUrl">点击查看</van-button></span>
              </div>
            </div>
          </van-tab>
          <van-tab title="操作日志">
            <div class="item">
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in operationLogList" :key="index">
                  <span style="font-weight: bold">{{item.remark}}</span>
                  <span style="margin-left: 8px">{{item.createTime}}</span>
                  <div v-for="(val,label) in item.listData" :key="label">
                    <div class="contLogSp">
                      <div>
                        <van-image style="width: 0.6rem; height: 0.6rem" :src="val.avatar" ></van-image>
                        <span style="margin-left: 10px;">{{val.userName}}</span>
                      </div>
                      <div>
                        <van-tag size="mini" :type="val.spStatus == 2?'success':val.spStatus == 3?'danger':'warning'">{{val.spStatus == 2?'已通过':val.spStatus == 3?'驳回':'审批中'}}</van-tag>
                        <span></span>
                        <span v-if="val.spTime" style="margin-left: 10px;">{{val.spTime}}</span>
                      </div>
                    </div>
                    <div v-if="val.spComment">{{val.spComment}}</div>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="1" v-hasPermi="['cont:accountRefundVerify:edit']" v-if="refundInfo.acconutStatus == 2">
        <van-grid-item>
          <div class="flex-center" @click="handleRefund(refundInfo)">
            <van-icon name="refund-o" size="22" color="#ee0a24" />
            <span>退款</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-dialog v-model="visible" title="媒介充值" width="95%" style="height:40%" class="reject_form" show-cancel-button :beforeClose="saveCashier">
        <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-field v-model="form.cashierUrl" label="充值截图" placeholder="请点击下方上传充值截图" :rules="[{ required: true }]" required readonly />
          <van-uploader class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
          <div style="color: #ff976a; font-size: 14px;">只能上传一张jpg/png格式图片，且不超过10mb</div>
        </van-form>
      </van-dialog>
      <van-image-preview v-model="imageShow" :images="imageArr">
        <!-- <template v-slot:index>第{{ index }}页</template> -->
      </van-image-preview>
    </div>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import newContract from '@/api/cont/newContract'
import refund from '@/api/fina/refund'
import { Toast, Dialog, ImagePreview } from 'vant'
export default {
  components: {
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      isShow: false,
      arvId: null,
      contractImg: require('../../../assets/images/desktop/contractName.png'),
      active: 0,
      refundInfo: {},
      batchRefundList: [],
      operationLogList: [], // 操作日志
      options: {
        accountTypeOptions: [{ dictLabel: '腾讯', dictValue: 1 }, { dictLabel: '巨量', dictValue: 2 }, { dictLabel: '百度', dictValue: 3 },
          { dictLabel: 'B站', dictValue: 4 }, { dictLabel: '京东', dictValue: 5 }, { dictLabel: '快手', dictValue: 6 }],
        acconutStatusOptions: [{ dictLabel: '企微审批中', dictValue: 1 }, { dictLabel: '通过待退款', dictValue: 2 },
          { dictLabel: '审批驳回', dictValue: 3 }, { dictLabel: '出纳已退款', dictValue: 4 }]
      },
      pictureList: [],
      imageShow: false,
      imageArr: [],
      visible: false,
      form: {
        arvId: null,
        cashierUrl: null
      }
    }
  },
  async created() {
    if (this.$route.query) {
      this.arvId = this.$route.query.arvId
    }
  },
  async mounted() {
    sessionStorage.setItem('rechargeSearch', true)
    await this.getRefundInfo()
    this.init()
  },
  methods: {
    async init() {
      document.title = '退款审批详情'
    },
    async getRefundInfo() {
      const res = await refund.getRefundVerify(this.arvId)
      if (res.code === 200) {
        this.refundInfo = res.data
        this.isShow = true
      }
      refund.listRefundDetail({ arvId: this.arvId }).then(res => {
        if (res.code === 200) {
          this.batchRefundList = res.rows
        }
      })
      // }
      this.getLogList()
    },
    // 获取操作记录
    async getLogList() {
      const params = {
        contractId: this.arvId,
        bigType: 13
      }
      newContract.listContractLog(params).then(response => {
        this.operationLogList = response.rows
      })
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast.fail('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast.fail('文件大小不能超过 10mb')
    },
    async uploadPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.cashierUrl = res.url
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
          Toast.fail(error)
        })
    },
    handleRemove(file) {
      this.form.cashierUrl = ''
      this.pictureList = []
      return true
    },
    async handleRefund() {
      this.form.arvId = this.arvId
      this.visible = true
    },
    // 认领
    async saveCashier(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.form.validate()
          refund.updateRefundVerify(this.form).then(res => {
            if (res.code == 200) {
              Toast.success(res.msg)
              this.visible = false
              setTimeout(() => {
                this.getRefundInfo()
              }, 1000)
            } else {
              Toast.fail(res.msg)
            }
          })
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    showImg(val) {
      this.imageArr = []
      this.imageArr.push(val)
      this.imageShow = true
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 80%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
/deep/.van-list{
  padding: 0;
}
.tagTitle{
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
.contract_detail{
  .item{
    display: inline-block;
  }
  .value{
    color: #333;
  }
}

.reject_form /deep/.van-dialog__content {
  height: 63%;
}
</style>
